/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsQueryOperator");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsQueryOperator>): ServiceAccountNativeDetailsQueryOperator {
        let obj = Object.assign(new ServiceAccountNativeDetailsQueryOperator(), model);
        ServiceAccountNativeDetailsQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsQueryOperator>): ServiceAccountNativeDetailsQueryOperator {
        if (!model) return null;
        return ServiceAccountNativeDetailsQueryOperator.newInstance(<ServiceAccountNativeDetailsQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsQueryOperator) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.native_details) {
            for (let val of this.native_details) {
                models.ServiceAccountNativeDetailsBase.fixupPrototype(val);
            }
        }
    }

    /**
     * Service Account Native Details to include
     */
    native_details: Array<models.ServiceAccountNativeDetailsBase>;

}
